<!-- 管理中心页面 -->
<template>
  <cc-container style="height:100%;">
    <cc-main>
       <cc-pull-refresh  :value="isLoading" @refresh="onRefresh" class="pull-refresh" ref="main" >
    <skeleton v-if="showSkeleton"/>
    <div v-else-if="!showSkeleton">
      <cc-header-nav style="height:106px">
        <div slot="left" class="information">
          <div class="head_sculpture">
            <span></span>
            </div>
          <div class="user_information ">
          <div class="name-msg">
            <span class="name">{{name}}</span>
            <span class="role" v-if="role=='1'">采购商</span>
            <span class="role" v-else-if="role=='3'">分销商</span>
          </div>
          <span class="tel">{{mobile}}</span>
          </div>
        </div>

        <div slot="right" class="distributor-icon"  v-if="showDistributor">
          <!-- 代客下单 采购商点击该地址 后端重定向到管理中心切换回分销商页面 -->
         <a  @click="backDistributor">
            <p ><cc-svg-icon size=".20rem" class-name="distributor-icon-item" icon-class="distributorIcon"></cc-svg-icon></p>
          <!-- <p>分销商</p> -->
         </a>
        </div>
        <div slot="right" class="my-code" @click="codeshow=true" v-else-if="role=='3'">
              <p class="code"><cc-svg-icon size=".20rem" class-name="code-icon" icon-class="code"></cc-svg-icon></p>
          <!-- <p>邀请码</p> -->
        </div>
         <div slot="right" class="install-icon">
         <router-link to="/policy/list">
            <p class="set-up"><cc-svg-icon size=".20rem" class-name="install-icon-item" icon-class="install"></cc-svg-icon></p>
         </router-link>
        </div>
      </cc-header-nav>
      <div class="management">
        <!-- 采购商界面 -->
        <div v-if="role=='1'">
      <div class="operation">
        <ul class="operation-box">
          <li class="operation-item">
            <a href="/user/favlist?goback=2">
            <span class="operation-num">{{favNum>999?"999+":favNum}}</span>
            <p>收藏</p></a>
          </li>
           <li class="operation-item">
            <a href="/user/points?goback=2"><span class="operation-num">{{pointNum>999?"999+":pointNum}}</span>
            <p>积分</p></a>
          </li>
           <li class="operation-item">
            <a href="/user/buyrecord?goback=2"><span class="operation-num">{{buyrecord>999?"999+":buyrecord}}</span>
            <p>采购历史</p></a>
          </li>
           <li class="operation-item">
           <a href="/getcoupon/my-coupon?goback=2"> <span class="operation-num">{{coupon>999?"999+":coupon}}</span>
            <p>优惠券</p></a>
          </li>
        </ul>
      </div>
      <xpt-block>
        <div slot="title">我的订单</div>
        <div class="xpt-management">
           <ul class="operation-box">
          <li class="operation-item">
           <!-- <a href="/order/waitpaylist?goback=2"> -->
            <a href="javascript:void(0)" onclick="to('/orderer?id=1')">
            <span class="order-pay"></span>
            <p>待支付</p>
            <em class="tipNum" v-if="paidNum">{{paidNum>99?"99+":paidNum}}</em>
            </a>
          </li>
           <li class="operation-item">
            <!-- <a href="/order/list?goback=2"> -->
              <a href="javascript:void(0)" onclick="to('/orderer?id=2')">
              <span class="order-submit"></span>
            <p>待收货</p>
            <em class="tipNum" v-if="receivedNum">{{receivedNum>99?"99+":receivedNum}}</em>
            </a>
          </li>
           <li class="operation-item">
             <!-- <a href="/order/list?goback=2"> -->
               <a href="javascript:void(0)" onclick="to('/orderer?id=0')">
              <span class="invoice"></span>
            <p>全部订单</p></a>
          </li>
           <li class="operation-item">
           <a href="javascript:void(0)" onclick="to('/presell/order')">
              <span class="advance"></span>
            <p>预售订单</p>
           </a>
          </li>
        </ul>
        <div class="xpt-line"></div>
        </div>
      </xpt-block>

      <xpt-block>
        <div slot="title">退货/退款</div>
        <div class="xpt-management">
           <ul class="operation-box">
          <li class="operation-item">
            <a href="javascript:void(0)" onclick="to('/order/return')">
            <span class="return-management"></span>
            <p>退货单</p></a>
          </li>
           <li class="operation-item">
             <a href="javascript:void(0)" onclick="to('/order/refund')">
            <span class="drawback"></span>
            <p>退款单</p></a>
          </li>
            <li class="operation-item">
               <a href="javascript:void(0)" onclick="to('/order/invoice')">
            <span class="dispatch-list"></span>
            <p>发货单</p></a>
          </li>
        </ul>
        </div>
      </xpt-block>
      <xpt-block>
        <div slot="title">常用工具</div>
        <div class="xpt-management management-tool">
           <ul class="operation-box">
          <li class="operation-item">
            <a href="/user/info?goback=2">
              <span class="enterprise"></span>
            <p>企业信息</p>
            </a>
          </li>
           <li class="operation-item">
             <a href="javascript:void(0)" onclick="to('/invoice/list')">
              <span class="application"></span>
            <p>发票申请</p>
            </a>
          </li>
           <li class="operation-item">
            <router-link to="/receiver-address?path=/management">
              <span class="address"></span>
            <p>收货地址</p>
            </router-link>

          </li>
           <li class="operation-item">
             <router-link to="/my-credit">
               <span class="my-credit"></span>
               <p>我的账款</p>
              </router-link>
          </li>
             <li class="operation-item">
            <a href="/user/customerservice?goback=2">
              <span class="customer-service"></span>
            <p>客服</p>
            </a>
          </li>
           <li class="operation-item">
            <a href="/user/changepassword">
              <span class="change-password"></span>
            <p>修改密码</p>
            </a>
          </li>
           <li class="operation-item" @click="cancellationshow">
             <a href="javascript:void(0)">
              <span class="log-of"></span>
            <p>注销账号</p>
            </a>
          </li>
           <li class="operation-item" @click="signOut">
            <a href="/user/logout">
              <span class="sign-out"></span>
            <p>退出</p>
            </a>
          </li>
        </ul>
        </div>
      </xpt-block>
      </div>
      <!-- 分销商界面 -->
      <div v-else-if="role=='3'">
        <div class="invitation-code">
          <p>您的专属客户邀请码为: <span>{{invitecode}}</span>,通过邀请码注册的新客户将成为您的客户。</p>
        </div>
        <xpt-block>
         <div slot="title">客户管理</div>
         <div class="xpt-management distributor">
            <ul class="operation-box">
               <li class="operation-item">
                  <a href="javascript:void(0)" onclick="to('/myorder')">
                   <span class="my-order"></span>
                 <p>我的订单</p>
                </a>
               </li>
                <li class="operation-item">
                 <a href="/distributor/memberbuylist">
                   <span class="my-customer"></span>
                 <p>我的客户</p>
                 </a>
               </li>
                <li class="operation-item">
                  <a href="javascript:void(0)" onclick="to('/distributor/buyorderlist')">
                   <span class="achievements"></span>
                 <p>我的业绩</p>
                 </a>
               </li>
                <li class="operation-item">
                 <a href="/distributor/refund">
                   <span class="return-order"></span>
                 <p>客户退单</p>
                 </a>
               </li>
                <li class="operation-item">
                 <a href="/distributor/myarea">
                   <span class="distribution-area"></span>
                 <p>分销区域</p>
                 </a>
               </li>
          </ul>
          </div>
        </xpt-block>
        <xpt-block>
          <div slot="title">采购管理</div>
          <div class="xpt-management distributor">
             <ul class="operation-box">
           <li class="operation-item">
             <a href="javascript:void(0)" onclick="to('/purchase/history')">
               <span class="purchase-plan"></span>
             <p>采购计划</p>
             </a>
           </li>
            <li class="operation-item">
              <a href="javascript:void(0)" onclick="to('/purchase/product-stocks')">
               <span class="procurement-area"></span>
             <p>采购专区</p>
             </a>
           </li>
         </ul>
         <div class="xpt-line2"></div>
         </div>
      </xpt-block>
      <xpt-block>
         <div slot="title">常用工具</div>
         <div class="xpt-management distributor">
            <ul class="operation-box">
               <li class="operation-item">
                 <a href="/user/info?goback=2">
                   <span class="user-information"></span>
                 <p>用户信息</p>
                 </a>
               </li>
                <li class="operation-item">
                 <a href="/user/customerservice?goback=2">
                   <span class="customer-service"></span>
                 <p>客服</p>
                 </a>
               </li>
                <li class="operation-item">
                 <a href="/user/changepassword">
                   <span class="change-password"></span>
                 <p>修改密码</p>
                 </a>
               </li>
                <li class="operation-item" @click="cancellationshow">
                 <a href="javascript:void(0)"><span class="cancellation-account"></span>
                 <p>注销账号</p></a>
               </li>
                <li class="operation-item" @click="signOut">
                 <a href="/user/logout"><span class="sign-out"></span>
                 <p>退出</p></a>
               </li>
          </ul>
          </div>
      </xpt-block>
      </div>
      <div class="bar">
        <van-swipe :show-indicators=false :touchable=false>
          <div v-if="swipelist!=''">
            <van-swipe-item>
              <a :href="swipelist.url==''?'javascript:void(0);':swipelist.url">
                <img :src="swipelist.image" />
              </a>
            </van-swipe-item>
          </div>
          <div v-else>
            <van-swipe-item>
              <a>
                <img src="./../../../assets/img/kgbg_one.png" />
              </a>
            </van-swipe-item>
          </div>
        </van-swipe>
      </div>
      </div>

      </div>
  </cc-pull-refresh>
    </cc-main>
    <cc-footer>
      <cc-nav></cc-nav>
    </cc-footer>
    <!-- 二维码弹窗 -->
        <van-dialog v-model="codeshow" class="pup_activey" :showConfirmButton=false :closeOnClickOverlay=true>
          <div class="code_parents">
       <div class="code-pup">
         <p><img :src="code"  alt=""></p>
         <span>扫描二维码，成为我的客户</span>
         <div class="codeclose" @click="codeshow=false">
         </div>
       </div>
       </div>
    </van-dialog >

     </cc-container>

</template>

<script>
import { ResultCode } from '~const/ResultCode'
import ListMixin from '@/mixins/list'
import xptBlock from './xptblock.vue'
import Skeleton from './skeleton.vue'
import { loadManage, loadInformation } from '../../../fetch/manage-center/management/index.js'
import Vue from 'vue'
import { Dialog, Swipe,
  SwipeItem, PullRefresh, Loading } from 'vant'
Vue.use(Dialog)
  .use(Swipe)
  .use(SwipeItem)
  .use(PullRefresh)
  .use(Loading)
export default {
  name: 'management',
  components: { xptBlock, Skeleton },
  mixins: [ListMixin],
  data () {
    return {
      showSkeleton: true,
      role: '', // 判断是分销商还是采购商 1是采购商 3是分销商
      favNum: 0, // 收藏
      pointNum: 0, // 积分
      buyrecord: 0, // 采购历史
      coupon: 0, // 优惠券
      // 无待支付数据或无待收货是否隐藏
      paidNum: 0, // 待支付
      receivedNum: 88, // 待收货
      codeshow: false, // 二维码弹窗
      swipelist: [],
      name: '', // 用户名称
      mobile: '', // 手机号码
      invitecode: '', // 邀请码数字
      code: '', // 二维码图片地址
      showDistributor: false, // 返回分销商
      isLoading: false
      // loadingShow: true

    }
  },
  computed: {

  },
  created () {
    this.loadData()
  },
  methods: {
    // window跳转可以解决页面缓存的问题
    backDistributor () {
      window.location.href = '/distributor/index'
    },
    // 下拉刷新
    onRefresh () {
      this.isLoading = true
      this.loadData()
    },
    tomansgement () {
      this.loadData()
    },
    cancellationshow () {
      Dialog.alert({
        message: '如需注销账号，请联系客服',
        closeOnClickOverlay: true,
        confirmButtonText: '确定'
      }).then(() => {
        // on confirm
      })
    },
    // 加载数据
    async loadData () {
      await Promise.all([
        loadInformation(),
        loadManage()

      ]).then(values => {
        if (values[1].status === ResultCode.SUCCESS) {
          this.isLoading = false
          this.showDistributor = false
          this.showSkeleton = false
          if (values[0].data.is_replace && values[1].data.is_replace * 1 !== 0) {
            this.$set(this, 'showDistributor', true)
          }
          if (values[0].data.ad) {
            this.swipelist = values[0].data.ad
          }
          if (values[0].data.member_info.type === '1') {
            this.role = values[0].data.member_info.type
            this.name = values[0].data.member_info.company_name
            this.mobile = values[0].data.member_info.mobile
          }
          if (values[0].data.member_info.type === '3') {
            this.role = values[0].data.member_info.type
            this.name = values[0].data.member_info.contacter
            this.mobile = values[0].data.member_info.mobile
            this.invitecode = values[0].data.member_info.invite_code
            this.code = values[0].data.member_info.code
          }
          this.favNum = +values[1].data.fav_count
          this.pointNum = +values[1].data.member_points
          this.buyrecord = +values[1].data.buyrecord_count
          this.coupon = +values[1].data.coupon_count
          this.paidNum = +values[1].data.waitpaycount
          this.receivedNum = +values[1].data.receive_count
        }
      })
    },
    signOut () {
      // 清楚登录的缓存标记
      window.sessionStorage.removeItem('login')
      // 清除加载骨架屏的标记
      window.sessionStorage.removeItem('roleType')
    }
  },
  activated () {
    if (sessionStorage.getItem('scrollman') && this.$refs.main) {
      this.$refs.main.$el.scrollTop = sessionStorage.getItem('scrollman')
    }
  },
  deactivated () {
    if (this.$refs.main) {
      sessionStorage.setItem('scrollman', this.$refs.main.$el.scrollTop)
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'orderer') {
      !this.$keeplive.includes('orderManagent') && this.$keeplive.push('orderManagent')
    }
    next()
  }

}
</script>
<style lang='scss' scoped>
@import "~styles/index.scss";
/deep/.cc-header-left{
   width: auto !important;
}
/deep/.cc-header-right{
  position: relative;
   z-index: 25;
   width: auto !important;
   margin-bottom: 18px;
}
/deep/.cc-header::before{
  content: "";
  position: absolute;
  top: 0;
  width: 100%;
  height: 106px;
  background-image: url("./../../../assets/img/management/wave.png") ;
  background-size: 100% ;
  z-index: 1;
  opacity: 0.7;
}
.information{
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 15px;
}
.head_sculpture{
  width: 43px;
  height: 43px;
  border-radius: 50%;
  margin: 0 10px 0 20px;
  z-index: 22;
  img{
    width: 100%;
    height: 100%;
  }
}
.user_information{
  // width: 70px;

  display: flex;
  flex-direction: column;
  text-align: left;
  line-height: 20px;
  margin-top: 10px;
  // max-width: 175px;
}
.name-msg{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.name{
  display: inline-block;
    font-size: 14px;
    max-width: 160px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
    line-height: 16px;
}
.tel{
font-size: 12px;
color: #EEEEEEFF;
}
.role{
  font-size: 12px;
  display: inline-block;
  width: 45px;
  height: 16px;
  line-height: 16px;
  margin-left: 12px;
  // margin-top: -10px;
  background-color: var(--APP_theme_color_colorOpacity5);
  position: relative;
  text-indent: 2px;

}
.role:before{
    content: "";
               width: 0px;
               height: 0px;
               border-top: 8px solid transparent;
               border-bottom: 8px solid transparent;
               border-right: 8px solid var(--APP_theme_color_colorOpacity5);
               position: absolute;
               top: 0px;
               left: -8px;
  }
.manage-block{
  background-color: #fff;
  border-radius: 10px;
  margin: 0 .1rem;
}
.operation{
  margin: -23px 10px 0 10px;
  background-color: #fff;
  border-radius: 10px;
  position: relative;
  z-index: 9999999;
  &-box{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction:row;
    justify-content:space-around;
    align-items: center;
    padding: 10px 0;
  }
  &-item a{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    font-size: 12px;
    flex-wrap: wrap;
    span{
      margin-bottom: 8px;
      font-weight: 700;
      font-size: 14px;
      color: #777;
    }

  }
}
.distributor-icon a,
.my-code{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  margin-right: 10px;

}

.code-icon{
  // margin-bottom: 5px;
  margin-right: 5px;
    color: #fff;
  }
.refresh-icon,.release-refresh{
  margin-right: 5px;
}
.distributor-icon-item{
  // margin-bottom: 5px;
  margin-right: 5px;
  color: #fff;
  // background: #fff;
}
.install-icon-item{
  color: #fff;
  margin-right: 15px;
  // margin-bottom: 5px;
}

.xpt-management{
  position: relative;
  .operation-item{
    position: relative;
    .tipNum{
      position: absolute;
      right: -12px;
      top: -6px;
      box-sizing: border-box;
      // padding:0 5px;
      min-width: 20px;
      height: 12px;
      background-color: #F5645BFF;
      color: #fff;
      font-size: 9px;
       display: flex;
       align-items: center;
       justify-content: center;
      border-radius: 6px;
    }
  }
  // 采购商精灵图
  span {
      width: 25px;
      height: 25px;
      display: inline-block;
      background: url("./../../../assets/img/management/purchasericon.png") no-repeat;
      margin-bottom: 16px;
      background-size:175px 175px;
    }
    .order-pay{
      background-position: -15px 0px;
    }
    .order-submit{
      background-position: -52px 0px;
    }
    .invoice{
      background-position: -89px 0px;
    }
    .advance{
      background-position: -129px 0px;
    }
    .return-management{
      width: 32px;
      height: 30px;
      background-position: -10px -37px;
    }
    .drawback{
      width: 32px;
      height: 30px;
      background-position: -47px -37px;
    }
    .dispatch-list{
      width: 32px;
      height: 30px;
      background-position: -87px -37px;
    }
   .enterprise{
      width: 32px;
      height: 30px;
      background-position: -10px -74px;
    }
    .application{
      width: 32px;
      height: 30px;
      background-position: -48px -74px;
    }
    .address{
      width: 32px;
      height: 30px;
      background-position: -87px -74px;
    }
    .my-credit{
      width: 32px;
      height: 30px;
      background-position: -125px -74px;
    }
     .change-password{
      width: 32px;
      height: 30px;
      background-position: -10px -111px;
    }
    .customer-service{
      width: 32px;
      height: 30px;
      background-position: -48px -111px;
    }
    .log-of{
      width: 32px;
      height: 30px;
      background-position: -87px -111px;
    }
    .sign-out{
      width: 32px;
      height: 30px;
      background-position: -125px -111px;
    }
    .xpt-line{
      width: 1px;
      height: 50px;
      background-color: #F6F5F5FF;
      position: absolute;
      top: 50%;
      left: 73%;
      transform: translate(-50%,-50%);
    }
    .xpt-line2{
      width: 1px;
      height: 50px;
      background-color: #F6F5F5FF;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
    }
}
.management-tool{
  .operation-box{
   flex-wrap: wrap;
  }
  .operation-item {
    width: 80px;
    height: 60px;
  }

}
//分销商
.invitation-code{
 width: 355px;
 height: 55px;
 margin: 0 auto;
 margin-top: -27px;
background-color: #fff;
 border-radius: 10px;
  background: url("./../../../assets/img/management/bg.png") no-repeat ;
  background-size: 100%;
 p{
    color: #666666FF;
    font-size: 12px;
    padding:10px 10px 0px 20px;
 }
span{
  color: #FF5B7AFF;
}
}
//分销商精灵图
.distributor{
  span {
      width: 32px;
      height: 30px;
      display: inline-block;
      background: url("./../../../assets/img/management/distributoricon.png") no-repeat;
      margin-bottom: 16px;
      background-size:230px 230px;
    }

   .my-order{
      background-position: -10px -10px;
    }
    .my-customer{
      background-position: -45px -10px;
    }
    .achievements{
      background-position: -80px -10px;
    }
    .return-order{
      background-position: -118px -10px;
    }
    .distribution-area{
      background-position: -153px -10px;
    }
   .purchase-plan{
      background-position: -10px -47px;
    }
    .procurement-area{
      background-position: -47px -48px;
    }
    .user-information{
      background-position: -10px -87px;
    }
    .customer-service{
      background-position: -48px -87px;
    }
     .change-password{
      background-position: -86px -87px;
    }
    .cancellation-account{
      background-position: -124px -87px;
    }
    .sign-out{
      background-position: -162px -87px;
    }
}
/deep/ .cc-header-right{
  width: 90px;
}
 .head_sculpture{

   >span{
     background: url("./../../../assets/img/management/distributoricon.png") no-repeat;
      margin-bottom: 16px;
      background-size:230px 230px;
     display: inline-block;
     width: 45px;
     height: 45px;
     background-position: -12px -125px;
   }
   }
/deep/.van-dialog{
    background-color:transparent;
}
.code_parents{
  height: 410px;
}
.code-pup{
  position: relative;
  width: 315px;
  height: 330px;
  // background-color: #fff;
   background: url("./../../../assets/img/management/codebg.png") no-repeat;
    background-size:100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  p{
    width: 186px;
    height: 186px;
    margin-bottom: 15px;
    padding: 20px;
    background-color: #EBDACAFF;
    border-radius: 10px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  span{
    font-size: 14px;
    color: #333333FF;
  }
}
  .codeclose{
    position: absolute;
    bottom: -74px;
    left: 50%;
    transform: translateX(-50%);
     background: url("./../../../assets/img/management/codeclose.png") no-repeat;
     background-size: 100%;
    width: 34px;
    height: 74px;
}
.cancellation-pup{
  width: 270px;
  height: 270px;
  background-color: #fff;
}
.bar{
  height: 140px;
   border-radius: 10px;
  overflow: hidden;
   background: #fff;
  margin: .1rem;
  img{
    width: 100%;
    height:140px;
  }
}
/deep/.van-swipe{
  height: 100%;
  width: 100%;
}
.pull-refresh {
  height: 100%;
  /deep/ {
    > div {
      height: 100%;
    }
  }
}
/deep/.van-pull-refresh {
    overflow: auto!important;
}
</style>
